/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-27 16:21:45
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-04 10:08:44
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelCategory/ProductCategory/slice/index.ts
 */
import {
  createSlice,
  //createSelector,
  createAsyncThunk,
} from '@reduxjs/toolkit';
import {
  //getSearchCondition as _getSearchCondition,
  //reducerTarget,
  getIsSearching as _getIsSearching,
  getSearch as _getSearch,
  getRequestSearch as _getRequestSearch,
  getData as _getData,
  getCollapse as _getCollapse,
  getLoaded as _getLoaded,
  getMoveList as _getMoveList,
  getRootUuid as _getRootUuid,
  getOrder as _getOrder,
} from 'src/pages/SalesChannelCategory/slice/common';
// import //searchConditions,
//   getStateTarget as getTarget,
// 'src/tools/helper';
import {
  getCategories,
  postCategoryProductsMove,
  deleteCategory,
  postCategoryProductsSearch,
} from 'src/request/category';
import { onTagClose1 } from 'src/constrains/Query1/tools';
//import { generateDefaultCategory } from './common';
import { EnumReducers } from 'src/pages/SalesChannelCategory/slice/constants';
import { getState, dispatch } from 'src/store';
import {
  convertDataFromServerToReduxNoSearch,
  convertDataFromServerToReduxHasSearch,
} from 'src/pages/SalesChannelCategory/PagesCategory/tools';

//const getTarget = (state) => reducerTarget(state, [EnumReducers.products]);

// const _isSearching = () => {
//   const state = getState();
//   const isSearching = getIsSearching()(state);

//   return { isSearching };
// };

const resetSearch = () => {
  dispatch(emptySearch());
};

function buildState({ state, data, searchingStatusHasChanged, isSearching }) {
  if (isSearching) {
    convertDataFromServerToReduxHasSearch({
      state,
      data,
      searchingStatusHasChanged, //因为发请求都取消search
    });
  } else {
    convertDataFromServerToReduxNoSearch({
      state,
      data,
      searchingStatusHasChanged,
    });
  }
}

export const fetchCategoriesProducts = createAsyncThunk(
  'fetchCategoriesProducts',
  async (params: { uuid }, thunkAPI) => {
    const { uuid } = params;

    const response = await getCategories(uuid);
    return { response };
  },
);

export const postProductsMove = createAsyncThunk(
  'postCategoryProductsMove',
  async (params: { body }, thunkAPI) => {
    const { body } = params;
    const response = await postCategoryProductsMove(body);
    return { response };
  },
);

export const postProductsSearch = createAsyncThunk(
  'postCategoryProductsSearch',
  async (params: { body }, thunkAPI) => {
    const { body } = params;
    const response = await postCategoryProductsSearch(body);
    return { response };
  },
);

export const deleteProductCategory = createAsyncThunk(
  'deleteCategory',
  async (params: { uuid }, thunkAPI) => {
    const { uuid } = params;
    const response = await deleteCategory(uuid);
    return { response };
  },
);

const defaultState = {
  isEditing: false,
  search: [],
  //addNewCategoryList: [],
  ///currentEditing: {},
  dataSet: {}, //{uuid:data}
  loaded: false,
  collapseOpen: {},
  rootUuid: null,
  allNodesWithOrder: [], //所有的节点uuid
  order: [], //只有当前显示的顺序
};

const ProductCategory = createSlice({
  name: 'salesChannelProductsCategory',
  initialState: defaultState,
  reducers: {
    onCollapseChange(state, action) {
      const { id, status } = action.payload;
      state.collapseOpen[id] = status;
    },
    onSearchChange(state, action) {
      state.search.push(action.payload);
    },
    // onAddNewCategory(state, action) {
    //   const { salesChannelUuid } = action.payload;
    //   const _c = generateDefaultCategory({ salesChannelUuid });
    //   state.addNewCategoryList.push(_c);
    // },
    onSearchTagClose(state, action) {
      const { item } = action.payload;
      onTagClose1({ state, item, conditionKey: undefined });
    },
    onDataUpdate(state, action) {
      const isSearching = state.search.length > 0;

      if (isSearching) {
        state.search = [];
      }
      const { data } = action.payload;

      buildState({
        state,
        data,
        isSearching: false,
        searchingStatusHasChanged: isSearching,
      });
    },
    emptySearch(state) {
      state.search = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCategoriesProducts.fulfilled, (state, action) => {
      const { response } = action.payload;
      const isSearching = state.search.length > 0;
      if (isSearching) {
        resetSearch();
      } else {
        buildState({
          state,
          data: response,
          isSearching: false,
          searchingStatusHasChanged: isSearching,
        });
      }
    });
    builder.addCase(postProductsMove.fulfilled, (state, action) => {
      const { response } = action.payload;
      const isSearching = state.search.length > 0;

      if (isSearching) {
        resetSearch();
      } else {
        buildState({
          state,
          data: response,
          isSearching: false,
          searchingStatusHasChanged: isSearching,
        });
      }
    });
    builder.addCase(deleteProductCategory.fulfilled, (state, action) => {
      const { response } = action.payload;
      const isSearching = state.search.length > 0;
      if (isSearching) {
        resetSearch();
      } else {
        buildState({
          state,
          data: response,
          isSearching: false,
          searchingStatusHasChanged: isSearching,
        });
      }
    });
    builder.addCase(postProductsSearch.fulfilled, (state, action) => {
      const { response } = action.payload;
      const stillInSearching = state.search.length > 0;
      buildState({
        state,
        data: response,
        isSearching: stillInSearching,
        searchingStatusHasChanged: !stillInSearching,
      });
    });
  },
});

const getIsSearching = () => {
  return _getIsSearching(EnumReducers.products);
};

const getLoaded = () => {
  return _getLoaded(EnumReducers.products);
};

// const isEditing = () => {
//   return createSelector(
//     (state: any) => {
//       const isAdding = getTarget(state).addNewCategoryList.length < 1;
//       const isEditing = !!!Object.keys(getTarget(state).currentEditing).find(
//         (i) => i,
//       );
//       return isAdding && isEditing;
//     },
//     (enable) => {
//       return enable;
//     },
//   );
// };

const getSearch = () => {
  return _getSearch(EnumReducers.products);
};

const getMoveList = (self) => {
  return _getMoveList(EnumReducers.products, self);
};

const getCollapse = (id) => {
  return _getCollapse(EnumReducers.products, id);
};

const getContent = (id) => {
  return _getData(EnumReducers.products, id);
};

const getRootUuid = () => {
  return _getRootUuid(EnumReducers.products);
};

const getRequestSearch = () => {
  const state = getState();
  const search = _getRequestSearch(EnumReducers.products)(state);
  return search;
};

const getOrder = () => {
  return _getOrder(EnumReducers.products);
};

export const {
  onSearchChange,
  //onAddNewCategory,
  onSearchTagClose,
  emptySearch,
  onCollapseChange,
  onDataUpdate,
} = ProductCategory.actions;
export {
  getIsSearching,
  getSearch,
  getRequestSearch,
  //isEditing,
  getContent,
  getCollapse,
  getLoaded,
  getMoveList,
  getRootUuid,
  getOrder,
};

export default ProductCategory.reducer;
